export default __webpack_public_path__ + "static/media/TTNorms-Regular.be9ab533.otf";